import {IconType} from "react-icons";

export enum KPIIconTypes {
  ALERTS_ACTIVE = "ALERTS_ACTIVE",
  ALERTS_IGNORED = "ALERTS_IGNORED",
  ALERTS_LAST = "ALERTS_LAST",
  ALERTS_RESOLVED = "ALERTS_RESOLVED",

  CHECKS_UP = "CHECKS_UP",
  CHECKS_DOWN = "CHECKS_DOWN",
  CHECKS_MAINTENANCE = "CHECKS_MAINTENANCE",
  CHECKS_PAUSED = "CHECKS_PAUSED",
  CHECKS_RUNNING = "CHECKS_RUNNING",

  INCIDENTS_IDENTIFIED = "INCIDENTS_IDENTIFIED",
  INCIDENTS_INVESTIGATING = "INCIDENTS_INVESTIGATING",
  INCIDENTS_MAINTENANCE = "INCIDENTS_MAINTENANCE",
  INCIDENTS_MONITORING = "INCIDENTS_MONITORING",
  INCIDENTS_RESOLVED = "INCIDENTS_RESOLVED",
  INCIDENTS_ACTIVE = "INCIDENTS_ACTIVE",
}

export const KPI_ICON_TYPES = Object.values(KPIIconTypes);
export type KPIIconType = (typeof KPI_ICON_TYPES)[number];

export type KPIIconDisplayConfig = {
  icon: IconType;
  borderColor: string;
  backgroundColor: string;
  iconColor: string;
};
